/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KnowledgeLinkBase = {
    icon: string;
    title: string;
    chip_type: string;
    link_type: KnowledgeLinkBase.link_type;
    url: string;
    sort_order: number;
};

export namespace KnowledgeLinkBase {

    export enum link_type {
        URL = 'url',
        EXTERNAL_URL = 'external_url',
        ASK_QUERY = 'ask_query',
    }


}

